var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Emit, Prop, Watch } from "vue-property-decorator";
import CheckApply from "~/components/visit-case/check-apply.vue";
import { Dependencies } from "~/core/decorator";
import { FlowTaskService } from "~/services/domain-service/flow-task.service";
import { CaseApplyRecordService } from "~/services/domain-service/case-apply-record.service";
var AssistApply = /** @class */ (function (_super) {
    __extends(AssistApply, _super);
    function AssistApply() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dataForm = {
            confirm: 0,
            caseIds: [],
            applyCategory: "",
            assistType: "",
            addressType: "HOUSE_ADDR",
            areaIds: [],
            areaId: "",
            addressDetail: "",
            visitEndDate: "",
            applyDescription: "",
            personalAddressId: ''
        };
        _this.checkMessages = {};
        _this.rules = {
            assistType: { required: true, message: "请选择协催类型" },
            addressType: { required: true, message: "请选择地址类型" },
            areaIds: { required: true, type: "array", message: "请选择省份/城市/区" },
            addressDetail: { required: true, message: "请输入外访地址" },
            visitEndDate: { required: true, message: "请选择协催到期时间" },
            applyDescription: { required: true, message: "请输入申请原因" }
        };
        _this.submitLoading = false;
        _this.dialog = false;
        return _this;
    }
    AssistApply.prototype.emitClose = function () {
        this.resetDate();
    };
    AssistApply.prototype.onOtherDataChange = function (val) {
        var _this = this;
        if (!val)
            return;
        if (val.assistType) {
            this.$nextTick(function () {
                _this.dataForm.assistType = val.assistType;
                _this.dataForm.personalAddressId = val.personalAddressId;
                _this.dataForm.addressType = val.addressType;
                _this.dataForm.addressStatus = val.addressStatus;
            });
        }
    };
    Object.defineProperty(AssistApply.prototype, "assistTypeShow", {
        /**
         * 表单项显示
         */
        get: function () {
            return (this.dataForm.assistType === "ASSIT_VISIT" &&
                this.dataForm.assistType !== "SELF_VISIT" && !this.isAddress);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssistApply.prototype, "assistType", {
        //过滤协催类型
        get: function () {
            // 要过滤的字段
            var disabledAssistTypes = ["LAWER_IN", "LAWER_OUT", "SELF_VISIT", "CHEAT", "LAWER"];
            // 增加过滤
            if (this.disabledType && this.disabledType.length) {
                disabledAssistTypes.push.apply(disabledAssistTypes, this.disabledType);
            }
            return this.$dict
                .getDictData("AssistType")
                .filter(function (v) { return !disabledAssistTypes.includes(v.code); });
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 提交
     */
    AssistApply.prototype.commit = function () {
        var _this = this;
        var dataFrom = this.$refs["dataFrom"];
        dataFrom.validate(function (valid) {
            if (!valid)
                return false;
            _this.commitNext();
        });
    };
    /**
     * 检查案件
     */
    AssistApply.prototype.commitNext = function () {
        var _this = this;
        this.flowTaskService
            .checkApplyCategory({ applyCategory: this.applyType })
            .subscribe(function (data) {
            // 0 拒绝，1 提示，2 通过
            if (data.status === 1) {
                _this.$confirm("该" +
                    _this.$dict.getDictName(_this.applyType, "ApplyCategory") +
                    "申请将直接生效，是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(function () {
                    _this.submit();
                })
                    .catch(_this.error);
            }
            else if (data.status === 2) {
                _this.submit();
            }
        }, this.error);
    };
    /**
     * 提交接口调用
     */
    AssistApply.prototype.submit = function () {
        this.submitLoading = true;
        this.dataForm.caseIds = this.caseIds;
        this.dataForm.applyCategory = this.applyType;
        this.dataForm.areaId = this.dataForm.areaIds[this.dataForm.areaIds.length - 1];
        this.dataForm.visitEndDate = this.$filter.dateFormat(this.dataForm.visitEndDate);
        this.caseApplyRecordService
            .applyCaseAssist(this.dataForm)
            .subscribe(this.success, this.error);
    };
    /**
     * 申请成功
     */
    AssistApply.prototype.success = function (data) {
        if (data && data.status !== 2) {
            this.checkMessages = data;
            this.dialog = true;
        }
        else {
            this.submitLoading = false;
            this.$message.success("操作成功");
            this.emitClose();
        }
    };
    /**
     * 失败
     */
    AssistApply.prototype.error = function () {
        this.submitLoading = false;
    };
    /**
     * 取消
     */
    AssistApply.prototype.cancelContinue = function () {
        this.dialog = false;
        this.submitLoading = false;
    };
    /**
     * 继续提交
     */
    AssistApply.prototype.confirmSubmit = function () {
        this.dataForm.confirm = 1;
        this.submit();
    };
    /**
     * 数据重置
     */
    AssistApply.prototype.resetDate = function () {
        this.dataForm = {
            confirm: 0,
            caseIds: [],
            applyCategory: "",
            assistType: "",
            addressType: "HOUSE_ADDR",
            areaIds: [],
            addressDetail: "",
            visitEndDate: "",
            areaId: "",
            applyDescription: "",
            personalAddressId: ''
        };
        var form = this.$refs["dataFrom"];
        form.resetFields();
        this.checkMessages = {};
    };
    __decorate([
        Dependencies(FlowTaskService)
    ], AssistApply.prototype, "flowTaskService", void 0);
    __decorate([
        Dependencies(CaseApplyRecordService)
    ], AssistApply.prototype, "caseApplyRecordService", void 0);
    __decorate([
        Prop({ type: String })
    ], AssistApply.prototype, "applyType", void 0);
    __decorate([
        Prop({ type: Array, required: true })
    ], AssistApply.prototype, "caseIds", void 0);
    __decorate([
        Prop({ type: Object })
    ], AssistApply.prototype, "otherData", void 0);
    __decorate([
        Prop({ type: Array })
    ], AssistApply.prototype, "disabledType", void 0);
    __decorate([
        Prop()
    ], AssistApply.prototype, "isAddress", void 0);
    __decorate([
        Emit("close")
    ], AssistApply.prototype, "emitClose", null);
    __decorate([
        Watch("otherData", { immediate: true })
    ], AssistApply.prototype, "onOtherDataChange", null);
    AssistApply = __decorate([
        Component({
            components: {
                CheckApply: CheckApply
            }
        })
    ], AssistApply);
    return AssistApply;
}(Vue));
export default AssistApply;
